import React from 'react'

/**
 * Ensures that `state[property]` is kept up to date with `value`.
 */
export function useInjectValue<T extends object, TProp extends keyof T>(state: T, property: TProp, value: T[TProp]) {
    React.useEffect(() => {
        state[property] = value
    }, [state, property, value])
}

/**
 * Ensures that `state[property]` is kept up to date with value returned by `useHook`.
 */
export function useInject<T extends object, TProp extends keyof T>(state: T, property: TProp, useHook: () => T[TProp]) {
    const value = useHook()

    useInjectValue(state, property, value)
}
